import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import contactImg from '../assets/contact.png';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .send(
        SERVICE_ID,
        TEMPLATE_ID,
        { name: form.name, email: form.email, message: form.message, title: 'New Contact Form Submission' },
        { publicKey: PUBLIC_KEY }
      )
      .then(() => {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      })
      .catch((err) => {
        console.error('EmailJS error:', err);
        setStatus('error');
      });
  };

  return (
    <section id="contact" className="scroll-mt-28 bg-gray-50 px-6 py-16 sm:py-20" data-aos="fade-up">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-3xl font-bold text-center text-teal-700 mb-10">Contact Us</h2>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden grid md:grid-cols-2">
          <img src={contactImg} alt="Contact" className="w-full h-full object-cover min-h-[260px]" />

          <form onSubmit={handleSubmit} className="p-8 space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full border border-gray-200 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full border border-gray-200 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={form.message}
              onChange={handleChange}
              required
              className="w-full border border-gray-200 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            ></textarea>
            <button
              type="submit"
              disabled={status === 'sending'}
              className="w-full bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-teal-700 hover:shadow-md transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {status === 'sending' ? 'Sending...' : 'Send Message'}
            </button>

            {status === 'success' && (
              <p className="text-sm text-teal-700 text-center">Thank you for contacting us! We'll get back to you soon.</p>
            )}
            {status === 'error' && (
              <p className="text-sm text-red-600 text-center">Something went wrong sending your message. Please try again or email us directly.</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
